import App from 'next/app';
import { Provider } from 'react-redux';
import React from 'react';
import withRedux from 'next-redux-wrapper';
import Router from 'next/router';
import { parseCookies } from 'nookies';
import dynamic from 'next/dynamic';

import Footer from '../components/Footer';
import FooterV2 from '../components/Footer/footerV2';
import ErrorNotification from '../components/Notifications/ErrorNotification';
import HomePageFooter from '../components/Home/HomePageFooter';
import TrackingPixels from '../components/TrackingPixels';
import ScrollToTopRoute from '../components/hocs/ScrollToTopRoute';
import { updatePreviousRoute } from '../redux/actions/core-app-actions';
import makeStore from '../redux/store';

import { Rox, setup as RoxSetup } from '../utils/rollout';

import flagContainer from '../flagContainer';
import { roxKey } from '../config';

import '../styles/global.scss';

const Header = dynamic(() => import('../components/Header'), { ssr: false });
const Menu = dynamic(() => import('../components/Menu'), { ssr: false });

const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

const NoHeaderFooterRoutes = ['/webviews/australia-rankings'];

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};

        // const storeState = ctx.store.getState();
        // console.log('getInitialProps store', storeState);
        // Anything returned here can be accessed by the client
        return { pageProps };
    }

    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            themeV2: false,
            showHeaderAndFooter: false, // default to false to not show flash when webview are loaded
        };
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleMenuStateChange = this.handleMenuStateChange.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
    }

    componentDidMount() {
        const domainRegex = /(.*)myutr.com/;
        const matches = window.location.origin.match(domainRegex);
        if (matches !== null) {
            const newRoute = `${matches[1]}universaltennis.com`;
            window.location.replace(newRoute);
        }

        Router.events.on('routeChangeStart', () => {
            this.props.store.dispatch(updatePreviousRoute(window.location.pathname));
        });

        Router.events.on('routeChangeComplete', (url) => {
            const { coreApp } = this.props.store.getState();
            if (window && window.analytics) {
                const options = {};
                if (coreApp.previousRoute) {
                    options.referrer = coreApp.previousRoute;
                }
                window.analytics.page(url, options);
            }
        });

        if (canUseDOM) {
            try {
                Rox.register('featureFlags', flagContainer);
                RoxSetup(roxKey, { platform: 'SSR' });
            } catch (err) {
                console.log('client re-register of rox');
            }
        }

        if (flagContainer.themeV2.isEnabled()) {
            this.setState({
                themeV2: true,
            });
        }

        this.setState({
            showHeaderAndFooter: !NoHeaderFooterRoutes.includes(Router.pathname),
        });
    }

    handleMenuClick() {
        const { menuOpen } = this.state;
        this.setState({ menuOpen: !menuOpen });
    }

    handleMenuStateChange(state) {
        this.setState({ menuOpen: state.isOpen });
    }

    handleMenuClose() {
        this.setState({ menuOpen: false });
    }

    render() {
        const { themeV2, showHeaderAndFooter } = this.state;

        // Page props that were returned from 'getInitialProps' are stored in the props i.e. pageprops
        const { Component, pageProps, store } = this.props;
        const { menuOpen } = this.state;
        const cookies = parseCookies();
        const { jwt } = cookies;
        const isAuthenticated = jwt !== undefined;
        return (
            <div id="myutr-app-wrapper" className={`${themeV2 ? 'theme-v2' : 'pt84'} transparent ${showHeaderAndFooter ? '' : 'pt0'}`}>
                <Provider store={store}>
                    <TrackingPixels>
                        <ScrollToTopRoute>
                            {showHeaderAndFooter && (
                                <>
                                    <Header isAuthenticated={isAuthenticated} onMenuClick={this.handleMenuClick} />
                                    <Menu isAuthenticated={isAuthenticated} isOpen={menuOpen} onStateChange={this.handleMenuStateChange} onClose={this.handleMenuClose} />
                                </>
                            )}
                            <Component themeV2={themeV2} {...pageProps} />
                            {showHeaderAndFooter && (
                                <>
                                    {!themeV2 && <HomePageFooter />}
                                    {themeV2 ? <FooterV2 /> : <Footer />}
                                </>
                            )}
                            <ErrorNotification />
                        </ScrollToTopRoute>
                    </TrackingPixels>
                </Provider>
            </div>
        );
    }
}

// withRedux wrapper that passes the store to the App Component
export default withRedux(makeStore, { debug: false })(MyApp);
